import styles from "./preview-section.module.scss";
import animations from "./../animation/animations.module.scss";
import Image from "next/image";
import SharedAnimation from "@components/shared/animation";

type PreviewProps = {
    preview: {
        title: string;
        subtitle: string;
        content: string[];
        imageUrl: string;
    }
    isDifferentColor?: boolean;
    isCustomzePhoto?: boolean;
}
const PreviewSection = ({preview, isDifferentColor = false, isCustomzePhoto = false}: PreviewProps) => {
    return (
        <SharedAnimation render={(ref) => (
            <div className={isDifferentColor ? styles.container : ''}>
                <section ref={ref} className={`${styles.section} ${animations.scroll__animation}`}>
                    <div className={styles.section__head}>
                        <h1 className={styles.section__title}>{preview.title}</h1>
                        <p className={styles.section__subtitle}>{preview.subtitle}</p>
                    </div>
                    <div className={`${styles.section__image} ${isCustomzePhoto ? styles.section__imageCustom : ''}`}>
                        {!!isCustomzePhoto ? (
                            <Image src={preview.imageUrl} alt={preview.title} layout={"fill"} objectFit={'contain'} loading="eager" />
                        ) : (
                            <Image src={preview.imageUrl} alt={preview.title} layout={"fill"} loading="eager"/>
                        )}
                    </div>
                    <div className={styles.section__content}>
                        {preview.content.map((paragraph, idx) => (
                            <p key={idx} className={styles.section__content_item}>
                                {paragraph}
                            </p>
                        ))}
                    </div>
                </section>
            </div>
        )}/>
    );
}

export default PreviewSection;